import { useEffect } from "react";

export default function useLegacySlideCss(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const selector = 'link[data-legacy-slide="true"]';
    if (document.querySelector(selector)) return;

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/css/slide.css";
    link.setAttribute("data-legacy-slide", "true");
    document.head.appendChild(link);

    return () => {
      // Keep it loaded for subsequent routes to avoid flashes.
    };
  }, [enabled]);
}

